export default __webpack_public_path__ + "static/media/10-DroolingDonut.99ece33e.png";